import defineMessages from "../../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    addCard: {
        id: "tasks.rhythmSorting.addCard",
    },
});

export default messages;
